<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11">
    <path d="m1.25 1.25 8.5 8.5m0-8.5-8.5 8.5" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
